<template>
  <div class="parking-list">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>车位编号</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入车位编号" v-model="table.search.number"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>车辆车牌</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入车辆车牌" v-model="table.search.license"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>车位状态</p>
          </a-col>
          <a-col>
            <a-select class="app-block" v-model="table.search.status" placeholder="请选择车位状态">
              <a-select-option :value="1">出售</a-select-option>
              <a-select-option :value="2">出租</a-select-option>
              <a-select-option :value="3">空闲</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>住户名称</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入住户名称" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>住户电话</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入住户电话" v-model="table.search.phone"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="scanParking(data)" v-if="data.sale_state !== 3">查看</a-button>
          <a-button type="link" @click="parkingLog(data)">日志</a-button>
          <template v-if="!isPlatformRole">
            <a-button type="link" @click="parkingRegister(data)" v-if="data.sale_state === 3">登记</a-button>
            <a-button type="link" @click="changeLicense(data)" v-if="data.sale_state !== 3">变更车牌</a-button>
            <a-button type="link" @click="continueLease(data)" v-if="data.sale_state === 2 && data.sale_state !== 3">续租</a-button>
          </template>
        </a-space>
      </template>
    </a-table>
    <a-drawer width="80%" :title="drawerOne.title" :visible="drawerOne.show" destroy-on-close @close="drawerOne.show = false">
      <parking-log :id="drawerOne.id"></parking-log>
    </a-drawer>
    <a-drawer width="50%" :title="drawerTwo.title" :visible="drawerTwo.show" destroy-on-close @close="drawerTwo.show = false">
      <parking-register :id="drawerTwo.id" is-scan></parking-register>
    </a-drawer>
    <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmModal" width="50%" destroy-on-close centered>
      <parking-register ref="parkingRegister" :id="modal.id" :is-change-license="modal.isChangeLicense" :is-continue-lease="modal.isContinueLease" @confirm="submitParkingRegister"></parking-register>
    </a-modal>
  </div>
</template>

<script>
  import {
    parkingStatusText
  } from '@/io/dict.js';
  import ParkingService from '@/io/parking.js';
  import ParkingLog from '@/views/community/ParkingLog.vue';
  import ParkingRegister from '@/views/community/ParkingRegister.vue';

  export default {
    name: 'ParkingList',
    props: {
      communityId: {
        type: Number,
        default: null
      },
      id: {
        type: Number,
        default: null
      },
    },
    data() {
      let self = this;
      return {
        table: {
          loading: false,
          search: {
            number: null,
            license: null,
            status: [],
            name: null,
            phone: null
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '车位分区',
              dataIndex: 'car_port_garage.name'
            },
            {
              title: '车位编号',
              dataIndex: 'name'
            },
            {
              title: '车位状态',
              dataIndex: 'parkingStatusText'
            },
            {
              title: '车辆车牌',
              dataIndex: 'carNumberText'
            },
            {
              title: '所属房屋',
              dataIndex: 'carport_housing.housing.full_name'
            },
            {
              title: '住户姓名',
              dataIndex: 'owner.name'
            },
            {
              title: '住户电话',
              dataIndex: 'owner.mobile'
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        drawerOne: {
          id: null,
          title: '车位详情',
          show: false
        },
        drawerTwo: {
          id: null,
          title: '车位日志',
          show: false
        },
        modal: {
          id: null,
          title: null,
          show: false,
          loading: false,
          isChangeLicense: false,
          isContinueLease: false
        },
      }
    },
    components: {
      ParkingLog,
      ParkingRegister
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          if ((newValue || oldValue) && !this.table.loading) {
            this.searchTable();
          }
        },
        immediate: true
      },
      communityId: {
        handler(newValue, oldValue) {
          if ((newValue || oldValue) && !this.table.loading) {
            this.searchTable();
          }
        },
        immediate: true
      }
    },
    activated() {
      if (this.id || this.communityId) {
        this.initData();
      }
    },
    methods: {
      confirmModal() {
        this.modal.loading = true;
        this.$refs.parkingRegister.submit();
      },
      submitParkingRegister() {
        this.modal.loading = false;
        this.modal.show = false;
        this.initData();
      },
      parkingRegister(data) {
        this.$router.push({
          name: 'ParkingRegister',
          params: {
            id: data.id
          }
        });
      },
      scanParking(data) {
        this.drawerTwo.id = data.id;
        this.drawerTwo.show = true;
      },
      parkingLog(data) {
        this.drawerOne.id = data.id;
        this.drawerOne.show = true;
      },
      changeLicense(data) {
        this.modal.id = data.id;
        this.modal.title = '变更车牌';
        this.modal.isChangeLicense = true;
        this.modal.isContinueLease = false;
        this.modal.show = true;
      },
      continueLease(data) {
        this.modal.id = data.id;
        this.modal.title = '续租';
        this.modal.isChangeLicense = false;
        this.modal.isContinueLease = true;
        this.modal.show = true;
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          number: null,
          license: null,
          status: [],
          name: null,
          phone: null
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        this.$emit('total', 0);
        ParkingService.listPage(
          this.communityId,
          this.id ? [this.id] : null,
          1,
          this.table.search.number,
          this.table.search.license,
          this.table.search.status,
          this.table.search.name,
          this.table.search.phone,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.parkingStatusText = parkingStatusText(val.sale_state);
            val.carNumberText = val.car_number ? val.car_number.join('、') : null;
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
          this.$emit('total', res.meta.pagination.total);
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>